module.exports = __webpack_public_path__ + "img/company.94c45129.svg";